import { urlCustomerAddAddressV2, urlCustomerDefaultAddressV2, urlCustomerDeleteAddressV2, urlCustomerUpdateAddressV2 } from "@/api/endpoint";
import { isThemeHappy } from "@/event/theme/theme";
import { alertMessageConfirmDeleteAddressHappy, alertMessageConfirmDeleteAddressHappyEmpty } from "@/happyTheme/event/dashboard/address/alertMessageConfirmDeleteAddressHappy";
import { alertMessageEmptyHappy, alertMessageHappy } from "@/happyTheme/event/dashboard/alert/AlertMessageHappy";
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass";
import address from "@/storage/address";
import customer from "@/storage/customer";
import { configDeliveryZones } from "@/storage/setting/configDeliveryZones";
import stores from "@/storage/stores";
import { fetchPostAuthorizationCSRFV2 } from "@/utils/fetch/fetchPostAuthorizationCSRFV2";
import { fetchMe } from "@/utils/jwt/fetchMe";
import { getTokenByDevice } from "@/utils/jwt/getTokenByDevice";
import { setTokenDevice } from "@/utils/jwt/setTokenDevice";

export class AddressService {
    timeOut: TimeOutClass

    constructor() {
        this.timeOut = TimeOutClass.getInstance();
    }

    public async deleteAddress(addressId: number): Promise<any> {
        try {
            const data = { address_id: addressId };
            const response = await fetchPostAuthorizationCSRFV2(urlCustomerDeleteAddressV2, data);

            if (response.class === "success") {
                response.message = response.message + ", la popup va se fermer dans 3 secondes";
                const addressIndex = address.getAddressData().findIndex(addr => addr.address_id === addressId);
                if (addressIndex !== -1) {
                    address.getAddressData().splice(addressIndex, 1);
                }
            }

            if (isThemeHappy.value) {
                alertMessageConfirmDeleteAddressHappy.value = response;
                const idTimeOut = setTimeout(() => {
                    alertMessageConfirmDeleteAddressHappy.value = alertMessageConfirmDeleteAddressHappyEmpty;
                }, 3002);
                this.timeOut.setIdTimeout(idTimeOut);
            }
            return response;

        } catch (error) {
            // console.error("Error deleting address:", error);
        }
    }

    public async addAddress(addressData: any): Promise<any> {
        try {
            const user = customer.getCustomerData();
            const store = stores.getStoresData();
            const data = {
                customer_id: user.customer_id,
                company: addressData.company,
                city: addressData.city.city,
                code_postal_id: addressData.city.city_id,
                address: addressData.address,
                address_2: addressData.address_2,
                country_id: addressData.city.country,
                zone_id: addressData.zone.zone_id,
                store_id: store.store_id,
                default: addressData.default
            }

            const response = await fetchPostAuthorizationCSRFV2(urlCustomerAddAddressV2, data);

            if (response.class === "success") {
                const data = getTokenByDevice()

                const result = await fetchMe(data)

                setTokenDevice(result);
            }

            if (isThemeHappy.value) {
                alertMessageHappy.value = response;
                const idTimeOut = setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy;
                }, 3002);
                this.timeOut.setIdTimeout(idTimeOut);
            }
            return response;

        } catch (error) {
            // console.error("Error adding address:", error);
        }
    }

    public async updateAddress(updateData: any): Promise<any> {
        try {
            const addressFind = configDeliveryZones.value.find((address: any) => address.city_id === updateData.city.city_id || address.city_id === updateData.zone.code_postal_id);
            if (!addressFind) {
                alertMessageHappy.value = {
                    title: "Modifier une adresse",
                    class: "error",
                    message: "Adresse introuvable",
                    errors: []
                };
                return;
            }

            const user = customer.getCustomerData();
            const store = stores.getStoresData();

            const data = {
                address_id: updateData.address_id,
                customer_id: user.customer_id,
                company: updateData.company,
                city: addressFind.city,
                code_postal_id: addressFind.city_id,
                address: updateData.address_1,
                address_2: updateData.address_2,
                country_id: addressFind.country,
                zone_id: addressFind.zone_id,
                store_id: store.store_id,
                default: updateData.default
            }

            const response = await fetchPostAuthorizationCSRFV2(urlCustomerUpdateAddressV2, data);

            if (response.class === "success") {
                const data = getTokenByDevice()

                const result = await fetchMe(data)

                setTokenDevice(result);
            }

            if (isThemeHappy.value) {
                alertMessageHappy.value = response;
                const idTimeOut = setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy;
                }, 3002);
                this.timeOut.setIdTimeout(idTimeOut);
            }
            return response;

        } catch (error) {
            // console.error("Error updating address:", error);
        }
    }

    public async updateAddressDefault(addressId: number): Promise<any> {
        try {
            const user = customer.getCustomerData();
            const store = stores.getStoresData();
            const data = {
                address_id: addressId,
                customer_id: user.customer_id,
                store_id: store.store_id
            }

            const response = await fetchPostAuthorizationCSRFV2(urlCustomerDefaultAddressV2, data);

            if (response.class === "success") {
                const data = getTokenByDevice()

                const result = await fetchMe(data)

                setTokenDevice(result);
            }

            if (isThemeHappy.value) {
                alertMessageHappy.value = response;
                const idTimeOut = setTimeout(() => {
                    alertMessageHappy.value = alertMessageEmptyHappy;
                }, 3002);
                this.timeOut.setIdTimeout(idTimeOut);
            }

            return response;

        } catch (error) {
            // console.error("Error updating default address:", error);
        }
    }
}